import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import { CountryFlag } from '../../CountryFlag';

export const CountrySelectOption = React.forwardRef(
  (
    { data: { value }, children, innerProps, innerRef, isFocused }: any,
    ref
  ) => {
    return (
      <MenuItem
        buttonRef={innerRef}
        selected={isFocused}
        component="div"
        {...innerProps}
      >
        <CountryFlag offset="right" countryCode={value} />
        <span>{children}</span>
      </MenuItem>
    );
  }
);

CountrySelectOption.displayName = 'CountrySelectOption';
